import { IComboItem, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";

export default class RolService extends ServiceBase {
  //get = (data:{ id?: number }) : Promise<IResponse<IRol>> => this.GetFetch<IResponse<IRol>>('entity/rol', data);

  //find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, id?:number | null, nombre?:string, codigo?:string, activo?:boolean }) : Promise<IPaginatedResponse<IRol>> => 
  //  this.GetFetch<IPaginatedResponse<IRol>>('entity/rol/find', data);

  /*all = () : Promise<IResponse<IRol[]>> => 
    this.GetFetch<IResponse<IRol[]>>('entity/rol/all', {});
*/
  combo = (data: {}) : Promise<IResponse<IComboItem[]>> => 
    this.GetFetch<IResponse<IComboItem[]>>('entity/rol/combo', data);

  //upsert = (data:IRol) : Promise<IResponse<IRol>> => 
  //  this.PostFetch<IResponse<IRol>>('entity/rol', data);

  //delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
  //  this.DeleteFetch<IResponse<void>>('entity/rol', data);  
}
